<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import axios from "axios";
import moment from "moment";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import { required } from "vuelidate/lib/validators";
import { authFackMethods } from "@/state/helpers";

import { categories } from "../../views/user-profile/data-calendar";

export default {
  filters: {
    moment: function (date) {
      if (date === null) {
        return "";
      }
      return moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
    },
  },
  page: {
    title: "Scheduling",
    meta: [
      {
        name: "Scheduling",
      },
    ],
  },
  components: { DatePicker, FullCalendar, ckeditor: CKEditor.component },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      assignmentStatus: [
        { value: "awaiting_approval", text: "Awaiting Approval" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "InActive" },
        { value: "completed", text: "Completed" },
      ],

      startTime: "",
      endTime: "",
      calendarOptions: {
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        initialEvents: this.getCalendarAssignments,
        editable: true,
        droppable: false,
        eventResizableFromStart: true,
        dateClick: this.showTaskModal,
        eventClick: this.editEvent,
        eventsSet: this.handleEvents,
        weekends: false,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        events: this.calendarSchedules,
      },
      currentEvents: [],
      time: null,
      showModal: false,
      eventModal: false,
      categories: categories,
      submitted: false,
      submit: false,
      isCalendar: false,
      isDay: false,
      isWeek: false,
      isListing: true,
      schedules: {},
      dataFormat: {},
      newEventData: {},
      edit: {},
      deleteId: {},
      startTimeMonday: "",
      endTimeMonday: "",
      startTimeTuesday: "",
      endTimeTuesday: "",
      startTimeWednesday: "",
      endTimeWednesday: "",
      startTimeThursday: "",
      endTimeThursday: "",
      startTimeFriday: "",
      endTimeFriday: "",
      startTimeSaturday: "",
      endTimeSaturday: "",
      startTimeSunday: "",
      endTimeSunday: "",
      isMonday: false,
      isTuesday: false,
      isWednesday: false,
      isThursday: false,
      isFriday: false,
      isSaturday: false,
      isSunday: false,
      showMonday: true,
      showTuesday: true,
      showWednesday: true,
      showThursday: true,
      showFriday: true,
      showSaturday: true,
      showSunday: true,
      preservePage: 1,
      pageLimit: 50,
      event: {
        title: "",
        category: "",
      },
      editevent: {
        editTitle: "",
        editcategory: "",
      },
      typeSubmit: false,
      isAdd: false,
      isUpdate: false,
      noRecord: false,
      isLoading: false,
      isLoadingDay: false,
      isLoadingWeek: false,
      isLoadingTask: false,
      isUserTypeEmpty: false,
      isSlotsFull: false,
      statusDate: "",
      modalTitle: "",
      options: ["Yes", "No"],
      types: [{ value: "4", text: "Volunteer" }],
      locations: [],
      buildings: [],
      departments: [],
      timeFrame: [],
      roles: [],
      dayRoles: [],
      weekDays: [],
      times: [],
      approvers: [],
      users: [],
      tags: ["Tags-1", "Tags-2", "Tags-3"],
      checkStatus: {
        role: "",
        requested_date: "",
        approved_date: "",
        approvers: [this.user_id],
        status: "",
        assignment_id: "",
        user_id: "",
        user_name: "",
      },
      assignmentForm: {
        user_type_id: "",
        location_id: "",
        building_id: "",
        department_id: "",
        role_id: "",
        approver_id: "",
        started_at: "",
        ended_at: "",
        days: [],
        time: [],
        user_id: "",
        status: "",
        volunteers: [],
      },
      user_id: this.$route.params.id,
      editor: ClassicEditor,
      sendEmailForm: {
        subject: "",
        description: "<p>Content of the editor.</p>",
        receiver_id: null,
        receiver_name: null,
      },
      slots: {},
      task: {
        id: "",
        role_id: "",
        role_name: "",
        user_id: "",
        approver_id: [],
        date: "",
        slot_id: "",
        status: "",
      },
      calendarSchedules: "",
    };
  },
  validations: {
    assignmentForm: {
      user_type_id: { required },
      location_id: { required },
      building_id: { required },
      // department_id: { required },
      role_id: { required },
      approver_id: { required },
      started_at: { required },
      ended_at: { required },
    },
    event: {
      title: { required },
      category: { required },
    },
  },
  mounted() {
    this.getAssignments();
    this.getLocations();
    // this.getApprovers();
  },
  methods: {
    /**
     * Modal form submit
     */
    handleSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //   return;
      // }
      const title = this.event.title;
      const category = this.event.category.toString();
      let calendarApi = this.newEventData.view.calendar;
      console.log(title);
      console.log(category);
      console.log(calendarApi);

      this.currentEvents = calendarApi.addEvent({
        id: this.newEventData.length + 1,
        title,
        start: this.newEventData.date,
        end: this.newEventData.date,
        classNames: category + "dsa",
      });
      this.successmsg();
      this.showModal = false;
      this.newEventData = {};
      this.submitted = false;
      this.event = {};
    },

    hideModal() {
      this.submitted = false;
      this.showModal = false;
      this.event = {};
      this.$bvModal.hide("assign-task");
    },
    /**
     * Edit event modal submit
     */
    editSubmit() {
      console.log("das");
      this.submit = true;
      const editTitle = this.editevent.editTitle;
      const editcategory = this.editevent.editcategory.toString();
      this.edit.setProp("title", editTitle);
      this.edit.setProp("classNames", editcategory);
      this.successmsg();
      this.eventModal = false;
    },
    /**
     * Delete event
     */
    deleteEvent() {
      this.edit.remove();
      this.eventModal = false;
    },
    /**
     * Modal open for add event
     */
    dateClicked(info) {
      console.log("sdsad");
      this.newEventData = info;
      this.showModal = true;
    },
    /**
     * Modal open for edit event
     */
    editEvent(info) {
      console.log("edit event");
      console.log(info.event);
      this.edit = info.event;
      this.editevent.editTitle = this.edit.title;
      this.editevent.editcategory = this.edit.classNames.toString();
      this.eventModal = true;
    },
    closeModal() {
      this.eventModal = false;
    },
    confirm() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.deleteEvent();
          Swal.fire("Deleted!", "Event has been deleted.", "success");
        }
      });
    },
    /**
     * Show list of events
     */
    handleEvents() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      var dayValue = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
      var weekValue =
        moment(calendarApi.view.activeStart).format("YYYY-MM-DD") +
        "," +
        moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
      var monthValue = moment(calendarApi.view.currentStart).format("YYYY-MM");
      const type = calendarApi.view.type;
      if (type == "dayGridMonth") {
        document.getElementsByClassName("fc-view-harness")[0].style.display =
          "block";
        this.isDay = false;
        this.isWeek = false;
        this.getCalendarAssignments("month", monthValue);
      }
      if (type == "timeGridWeek") {
        this.isDay = false;
        this.isWeek = true;
        this.getWeekDates(weekValue);
        document.getElementsByClassName("fc-view-harness")[0].style.display =
          "none";
      }
      if (type == "timeGridDay") {
        this.isDay = true;
        this.isWeek = false;
        this.getRolesforDay(dayValue);
        document.getElementsByClassName("fc-view-harness")[0].style.display =
          "none";
      }
    },
    /**
     * Show successfull Save Dialog
     */
    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Event has been saved",
        showConfirmButton: false,
        timer: 1000,
      });
    },

    dataFormatView(value) {
      if (value == "calendar") {
        this.isCalendar = true;
        this.isListing = false;
        this.isDay = false;
        this.isWeek = false;
      } else {
        this.isListing = true;
        this.isCalendar = false;
        this.isDay = false;
        this.isWeek = false;
      }
    },

    getLocations() {
      axios.get("admin/locations?pagination=true&per_page=1000").then((res) => {
        this.locations = res.data.response.data;
      });
    },

    getBuildings() {
      axios.get("admin/buildings?pagination=true&per_page=1000").then((res) => {
        // this.buildings = res.data.response;
        console.log(res.data.response);
      });
    },

    getDepartment() {
      axios
        .get("admin/departments?pagination=true&per_page=1000")
        .then((res) => {
          this.departments = res.data.response.data;
        });
    },

    async getRoles() {
      await axios.get("admin/roles").then((res) => {
        this.roles = res.data.response.data;
      });
    },

    getRolesforDay(dayValue) {
      this.isLoadingDay = true;
      this.removeTableCells();

      axios.get("admin/roles?status=active").then((res) => {
        this.dayRoles = res.data.response;
        for (var i = 0; i < this.dayRoles.length; i++) {
          document
            .querySelectorAll("table.day-table tbody tr")
            .forEach((row) => {
              var x = row.insertCell(-1);
              x.setAttribute("data-role-id", this.dayRoles[i].id);
              x.style.backgroundColor = "#7f7f7";
              x.style.height = "30px";
            });
        }
        this.getCalendarAssignments("today", dayValue);
        this.isLoadingDay = false;
      });
    },

    async getWeekDates(weekValue) {
      await this.removeTableCells();
      const listDate = [];
      const startDate = weekValue.split(",").shift();
      const lastDate = weekValue.split(",").pop();
      const dateMove = new Date(startDate);
      let endDate = moment(lastDate).subtract(1, "days").format("YYYY-MM-DD");
      let strDate = startDate;

      while (strDate < endDate) {
        strDate = dateMove.toISOString().slice(0, 10);
        listDate.push(strDate);
        dateMove.setDate(dateMove.getDate() + 1);
      }

      this.isLoadingWeek = true;
      this.weekDays = listDate;
      if (this.weekDays.length > 1) {
        for (var i = 0; i < this.weekDays.length; i++) {
          document
            .querySelectorAll("table.week-table tbody tr")
            .forEach((row) => {
              var x = row.insertCell(-1);
              x.setAttribute("data-date", this.weekDays[i]);
              x.style.backgroundColor = "#f7f7f7";
              x.style.height = "30px";
            });
        }
      }
      await this.getCalendarAssignments("week", weekValue);
      this.isLoadingWeek = false;
    },

    async removeTableCells() {
      if (
        document.querySelectorAll("table.week-table tbody tr td").length > 0
      ) {
        await document
          .querySelectorAll("table.week-table tbody tr td")
          .forEach(function (e) {
            e.remove();
          });
      }
      if (document.querySelectorAll("table.day-table tbody tr td").length > 0) {
        await document
          .querySelectorAll("table.day-table tbody tr td")
          .forEach(function (e) {
            e.remove();
          });
      }
    },

    getApprovers() {
      axios.get("admin/approvers").then((res) => {
        this.approvers = res.data.response;
      });
    },

    async getUsers() {
      // await axios.get('admin/users/all/registered').then(res =>{
      //   this.users = res.data.response;
      // })
      await axios
        .get("admin/users/all/active?user_type_id=4&status=1")
        .then((res) => {
          this.users = res.data.response;
        });
    },

    getAssignments(page) {
      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === "undefined") {
        page = 1;
      }
      this.preservePage = page;
      let filter = "&per_page=" + this.pageLimit;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      }; // if (this.searchForm.name){
      //   filter += '&name='+ this.searchForm.name
      // }
      // if (this.searchForm.category){
      //   filter += '&category='+ this.searchForm.category
      // }
      // if (this.searchForm.status){
      //   filter += '&status='+ this.searchForm.status
      // }
      axios
        .get(
          "admin/schedule/users/assignment/" +
            this.user_id +
            "?pagination=true&page=" +
            page +
            filter,
          config
        )
        .then((res) => {
          this.schedules = res.data.response;
          this.isLoading = false;
          if (!this.schedules.data.length) {
            this.noRecord = true;
            if (page > 1) {
              this.getAssignments(page - 1);
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status == 401) {
              this.logout();
            }
          }
        });
    },
    ...authFackMethods,

    getCalendarAssignments(type, value) {
      if (type != "[object Object]") {
        axios
          .get(
            "admin/schedule/assignment/calender?type=" +
              type +
              "&value=" +
              value
          )
          .then((res) => {
            this.calendarSchedules = res.data.response;
            Array.from(this.calendarSchedules).forEach((data) => {
              if (type == "week") {
                this.checkWeeks(data);
              }
              if (type == "month") {
                this.checkDates(data);
              }
              if (type == "today") {
                this.checkDay(data);
              }
            });
          })
          .catch((err) => {
            if (err.response) {
              if (err.response.status == 401) {
                this.logout();
              }
            }
          });
      }
    },

    checkDay(data) {
      console.log(data);
      var time = "";
      data.slots.forEach((slot) => {
        time = slot.slot_time;
      });
      var addIcon =
        '<a href="javascript:;" class="text-white font-size-14"><i class="bx bx-plus"></i></a>';
      var viewIcon =
        '<a href="javascript:;" class="text-white font-size-14"><i class="bx bx-show"></i></a>';
      var bgColor = "";

      var targetTDs = document.querySelectorAll("table.day-table tbody tr");
      Array.from(targetTDs).forEach((row) => {
        if (time.toLowerCase() == row.getAttribute("data-time")) {
          var tds = row.getElementsByTagName("td");
          for (var i = 0; i < tds.length; i++) {
            if (data.role_id == tds[i].getAttribute("data-role-id")) {
              if (data.textColor.toLowerCase() == "red") {
                tds[i].innerHTML = addIcon;
                bgColor = "bg-danger";
                tds[i].addEventListener("click", () => {
                  this.showTaskModal(data);
                });
              }
              if (data.textColor.toLowerCase() == "green") {
                tds[i].innerHTML = viewIcon;
                bgColor = "bg-success";
              }
              if (data.textColor.toLowerCase() == "orange") {
                tds[i].innerHTML = addIcon;
                tds[i].addEventListener("click", () => {
                  this.showTaskModal(data);
                });
                bgColor = "bg-warning";
              }
              tds[i].classList.add(bgColor, "text-white", "text-center");
            }
          }
        }
      });
    },

    checkWeeks(data) {
      var time = "";
      data.slots.forEach((slot) => {
        time = slot.slot_time;
      });
      var addIcon =
        '<a href="javascript:;" class="text-white font-size-14"><i class="bx bx-plus"></i></a>';
      var viewIcon =
        '<a href="javascript:;" class="text-white font-size-14"><i class="bx bx-show"></i></a>';
      var bgColor = "";

      var targetTDs = document.querySelectorAll("table.week-table tbody tr");
      Array.from(targetTDs).forEach((row) => {
        if (time.toLowerCase() == row.getAttribute("data-time")) {
          var tds = row.getElementsByTagName("td");
          for (var i = 0; i < tds.length; i++) {
            if (data.date == tds[i].getAttribute("data-date")) {
              if (data.textColor.toLowerCase() == "red") {
                tds[i].innerHTML = addIcon;
                bgColor = "bg-danger";
                tds[i].addEventListener("click", () => {
                  this.showTaskModal(data);
                });
              }
              if (data.textColor.toLowerCase() == "green") {
                tds[i].innerHTML = viewIcon;
                tds[i].addEventListener("click", () => {
                  this.showTaskModal(data);
                });
                bgColor = "bg-success";
              }
              if (data.textColor.toLowerCase() == "orange") {
                tds[i].innerHTML = addIcon;
                tds[i].addEventListener("click", () => {
                  this.showTaskModal(data);
                });
                bgColor = "bg-warning";
              }
              tds[i].classList.add(bgColor, "text-white", "text-center");
            }
          }
        }
      });
    },

    checkDates(data) {
      var targetTDs = document.querySelectorAll("table tr > td");
      var addIcon =
        '<a href="javascript:;" class="text-white font-size-20"><i class="bx bx-plus"></i></a>';
      var viewIcon =
        '<a href="javascript:;" class="text-white font-size-20"><i class="bx bx-show"></i></a>';
      var bgColor = "";

      Array.from(targetTDs).forEach((row) => {
        if (data.date == row.getAttribute("data-date")) {
          row.querySelectorAll(".fc-daygrid-day-events").forEach((el) => {
            el.setAttribute("data-role-id", data.role_id);
            el.style.height = "64px";
            if (data.textColor.toLowerCase() == "red") {
              el.innerHTML = addIcon;
              bgColor = "bg-danger";
            }
            if (data.textColor.toLowerCase() == "green") {
              el.innerHTML = viewIcon;
              bgColor = "bg-success";
            }
            if (data.textColor.toLowerCase() == "orange") {
              el.innerHTML = addIcon;
              bgColor = "bg-warning";
            }
            el.classList.add(bgColor, "p-3", "text-white", "text-center");
          });
        }
      });
    },

    showDays() {
      this.showMonday = true;
      this.showTuesday = true;
      this.showWednesday = true;
      this.showThursday = true;
      this.showFriday = true;
      this.showSaturday = true;
      this.showSunday = true;
      var currDate = moment(this.assignmentForm.started_at)
        .subtract(1, "days")
        .startOf("day");
      var lastDate = moment(this.assignmentForm.ended_at).startOf("day");

      while (currDate.add(1, "days").diff(lastDate) <= 0) {
        var selectedDay = moment(currDate).format("dddd").toLowerCase();
        if (selectedDay == "monday") {
          this.showMonday = false;
        }
        if (selectedDay == "tuesday") {
          this.showTuesday = false;
        }
        if (selectedDay == "wednesday") {
          this.showWednesday = false;
        }
        if (selectedDay == "thursday") {
          this.showThursday = false;
        }
        if (selectedDay == "friday") {
          this.showFriday = false;
        }
        if (selectedDay == "saturday") {
          this.showSaturday = false;
        }
        if (selectedDay == "sunday") {
          this.showSunday = false;
        }
      }
    },

    addAssignment() {
      var formData = new FormData();

      if (this.assignmentForm.status == null) {
        this.assignmentForm.status = "awaiting_approval";
      }

      var volunteers = [this.user_id];
      console.log("volunteers");
      console.log(volunteers);
      // formData.append('user_id','')
      formData.append("user_type_id", this.assignmentForm.user_type_id);
      formData.append("location_id", this.assignmentForm.location_id);
      formData.append("building_id", this.assignmentForm.building_id);
      // formData.append('department_id',this.assignmentForm.department_id)
      formData.append("role_id", this.assignmentForm.role_id);
      formData.append("status", this.assignmentForm.status);
      formData.append("approver_id", this.assignmentForm.approver_id);
      formData.append("volunteers", volunteers);
      formData.append(
        "started_at",
        moment(this.assignmentForm.started_at, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        )
      );
      formData.append(
        "ended_at",
        moment(this.assignmentForm.ended_at, "YYYY-MM-DD").format("YYYY-MM-DD")
      );

      var arr = this.assignmentForm.days;

      for (var i = 0; i < arr.length; i++) {
        if (typeof arr[i] != "undefined") {
          formData.append("days[]", arr[i]);
        }
      }

      if (typeof this.assignmentForm.time[0] != "undefined") {
        formData.append(
          "time" + "[monday]" + "[start]",
          this.assignmentForm.time[0]
        );
      }
      if (typeof this.assignmentForm.time[1] != "undefined") {
        formData.append(
          "time" + "[monday]" + "[end]",
          this.assignmentForm.time[1]
        );
      }

      if (typeof this.assignmentForm.time[2] != "undefined") {
        formData.append(
          "time" + "[tuesday]" + "[start]",
          this.assignmentForm.time[2]
        );
      }
      if (typeof this.assignmentForm.time[3] != "undefined") {
        formData.append(
          "time" + "[tuesday]" + "[end]",
          this.assignmentForm.time[3]
        );
      }
      if (typeof this.assignmentForm.time[4] != "undefined") {
        formData.append(
          "time" + "[wednesday]" + "[start]",
          this.assignmentForm.time[4]
        );
      }
      if (typeof this.assignmentForm.time[5] != "undefined") {
        formData.append(
          "time" + "[wednesday]" + "[end]",
          this.assignmentForm.time[5]
        );
      }

      if (typeof this.assignmentForm.time[6] != "undefined") {
        formData.append(
          "time" + "[thursday]" + "[start]",
          this.assignmentForm.time[6]
        );
      }
      if (typeof this.assignmentForm.time[7] != "undefined") {
        formData.append(
          "time" + "[thursday]" + "[end]",
          this.assignmentForm.time[7]
        );
      }
      if (typeof this.assignmentForm.time[8] != "undefined") {
        formData.append(
          "time" + "[friday]" + "[start]",
          this.assignmentForm.time[8]
        );
      }
      if (typeof this.assignmentForm.time[9] != "undefined") {
        formData.append(
          "time" + "[friday]" + "[end]",
          this.assignmentForm.time[9]
        );
      }
      if (typeof this.assignmentForm.time[10] != "undefined") {
        formData.append(
          "time" + "[saturday]" + "[start]",
          this.assignmentForm.time[10]
        );
      }
      if (typeof this.assignmentForm.time[11] != "undefined") {
        formData.append(
          "time" + "[saturday]" + "[end]",
          this.assignmentForm.time[11]
        );
      }
      if (typeof this.assignmentForm.time[12] != "undefined") {
        formData.append(
          "time" + "[sunday]" + "[start]",
          this.assignmentForm.time[12]
        );
      }
      if (typeof this.assignmentForm.time[13] != "undefined") {
        formData.append(
          "time" + "[sunday]" + "[end]",
          this.assignmentForm.time[13]
        );
      }

      this.typeSubmit = true;
      this.$v.$touch();
      if (!this.$v.assignmentForm.$invalid) {
        var token = localStorage.getItem("token");
        var config = {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
          },
        };
        if (token) {
          axios
            .post("admin/assignments", formData, config)
            .then((res) => {
              if (res.status == "200") {
                Swal.fire({
                  title: "Good job!",
                  text: "Assignment added successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.getAssignments();
                this.$bvModal.hide("add-assignment");
                this.typeSubmit = false;
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true,
                });
              }
            });
        }
      }
    },

    updateAssignment() {
      var formData = new FormData();

      // formData.append('user_id',)
      formData.append("user_type_id", this.assignmentForm.user_type_id);
      formData.append("location_id", this.assignmentForm.location_id);
      formData.append("building_id", this.assignmentForm.building_id);
      // formData.append('department_id',this.assignmentForm.department_id)
      formData.append("role_id", this.assignmentForm.role_id);
      formData.append("status", this.assignmentForm.status);
      formData.append("user_id", this.assignmentForm.user_id);
      formData.append("approver_id", this.assignmentForm.approver_id);
      formData.append(
        "started_at",
        moment(this.assignmentForm.started_at, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        )
      );
      formData.append(
        "ended_at",
        moment(this.assignmentForm.ended_at, "YYYY-MM-DD").format("YYYY-MM-DD")
      );

      var arr = this.assignmentForm.days;

      for (var i = 0; i < arr.length; i++) {
        if (typeof arr[i] != "undefined") {
          formData.append("days[]", arr[i]);
        }
      }

      if (typeof this.assignmentForm.time[0] != "undefined") {
        formData.append(
          "time" + "[monday]" + "[start]",
          this.assignmentForm.time[0]
        );
      }
      if (typeof this.assignmentForm.time[1] != "undefined") {
        formData.append(
          "time" + "[monday]" + "[end]",
          this.assignmentForm.time[1]
        );
      }

      if (typeof this.assignmentForm.time[2] != "undefined") {
        formData.append(
          "time" + "[tuesday]" + "[start]",
          this.assignmentForm.time[2]
        );
      }
      if (typeof this.assignmentForm.time[3] != "undefined") {
        formData.append(
          "time" + "[tuesday]" + "[end]",
          this.assignmentForm.time[3]
        );
      }
      if (typeof this.assignmentForm.time[4] != "undefined") {
        formData.append(
          "time" + "[wednesday]" + "[start]",
          this.assignmentForm.time[4]
        );
      }
      if (typeof this.assignmentForm.time[5] != "undefined") {
        formData.append(
          "time" + "[wednesday]" + "[end]",
          this.assignmentForm.time[5]
        );
      }

      if (typeof this.assignmentForm.time[6] != "undefined") {
        formData.append(
          "time" + "[thursday]" + "[start]",
          this.assignmentForm.time[6]
        );
      }
      if (typeof this.assignmentForm.time[7] != "undefined") {
        formData.append(
          "time" + "[thursday]" + "[end]",
          this.assignmentForm.time[7]
        );
      }
      if (typeof this.assignmentForm.time[8] != "undefined") {
        formData.append(
          "time" + "[friday]" + "[start]",
          this.assignmentForm.time[8]
        );
      }
      if (typeof this.assignmentForm.time[9] != "undefined") {
        formData.append(
          "time" + "[friday]" + "[end]",
          this.assignmentForm.time[9]
        );
      }
      if (typeof this.assignmentForm.time[10] != "undefined") {
        formData.append(
          "time" + "[saturday]" + "[start]",
          this.assignmentForm.time[10]
        );
      }
      if (typeof this.assignmentForm.time[11] != "undefined") {
        formData.append(
          "time" + "[saturday]" + "[end]",
          this.assignmentForm.time[11]
        );
      }
      if (typeof this.assignmentForm.time[12] != "undefined") {
        formData.append(
          "time" + "[sunday]" + "[start]",
          this.assignmentForm.time[12]
        );
      }
      if (typeof this.assignmentForm.time[13] != "undefined") {
        formData.append(
          "time" + "[sunday]" + "[end]",
          this.assignmentForm.time[13]
        );
      }

      this.typeSubmit = true;
      this.$v.$touch();
      if (!this.$v.assignmentForm.$invalid) {
        var token = localStorage.getItem("token");
        var config = {
          headers: {
            Authorization: "Bearer " + token,
          },
        };
        if (token) {
          axios
            .post("admin/assignments/" + this.assignment_id, formData, config)
            .then((res) => {
              if (res.status == "200") {
                Swal.fire({
                  title: "Good job!",
                  text: "Assignment updated successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.getAssignments();
                this.$bvModal.hide("add-assignment");
                this.typeSubmit = false;
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true,
                });
              }
            });
        }
      }
    },

    showAddModal(info) {
      this.typeSubmit = false;
      this.getUsers();
      this.resetForm();
      this.newEventData = info;
      console.log(info);
      this.assignmentForm.started_at = info.dateStr;
      this.assignmentForm.ended_at = info.dateStr;
      this.isUpdate = false;
      this.isAdd = true;
      this.modalTitle = "Add Assignment";
      this.$bvModal.show("add-assignment");
    },

    showEditModal(schedule) {
      this.typeSubmit = false;
      this.resetForm();
      this.getUsers();
      this.getLocations();
      this.assignmentLocation(schedule.location_id, schedule.user_type_id);
      this.modalTitle = "Edit Assignment";
      this.$bvModal.show("add-assignment");
      this.assignment_id = schedule.id;
      console.log(schedule);
      this.assignmentForm.user_type_id = schedule.user_type_id;
      this.assignmentForm.location_id = schedule.location_id;
      this.assignmentForm.department_id = schedule.department_id;
      this.assignmentForm.building_id = schedule.building_id;
      this.assignmentForm.role_id = schedule.role_id;
      this.assignmentForm.approver_id = schedule.approver_id;
      this.assignmentForm.user_id = schedule.user_id;
      this.assignmentForm.status = schedule.status;
      this.assignmentForm.started_at = moment(
        schedule.started_at,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
      this.assignmentForm.ended_at = moment(
        schedule.ended_at,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");

      this.isMonday = false;
      this.isTuesday = false;
      this.isWednesday = false;
      this.isThursday = false;
      this.isFriday = false;
      this.isSaturday = false;
      this.isSunday = false;

      this.showMonday = true;
      this.showTuesday = true;
      this.showWednesday = true;
      this.showThursday = true;
      this.showFriday = true;
      this.showSaturday = true;
      this.showSunday = true;

      if (schedule.day == "monday") {
        this.isMonday = true;
        this.showMonday = false;
        this.startTimeMonday = schedule.start_time;
        this.endTimeMonday = schedule.end_time;
      }
      if (schedule.day == "tuesday") {
        this.isTuesday = true;
        this.showTuesday = false;
        this.startTimeTuesday = schedule.start_time;
        this.endTimeTuesday = schedule.end_time;
      }
      if (schedule.day == "wednesday") {
        this.isWednesday = true;
        this.showWednesday = false;
        this.startTimeWednesday = schedule.start_time;
        this.endTimeWednesday = schedule.end_time;
      }
      if (schedule.day == "thursday") {
        this.isThursday = true;
        this.showThursday = false;
        this.startTimeThursday = schedule.start_time;
        this.endTimeThursday = schedule.end_time;
      }
      if (schedule.day == "friday") {
        this.isFriday = true;
        this.showFriday = false;
        this.startTimeFriday = schedule.start_time;
        this.endTimeFriday = schedule.end_time;
      }
      if (schedule.day == "saturday") {
        this.isSaturday = true;
        this.showSaturday = false;
        this.startTimeSaturday = schedule.startTime;
        this.endTimeSaturday = schedule.endTime;
      }
      if (schedule.day == "sunday") {
        this.isSunday = true;
        this.showSunday = false;
        this.startTimeSunday = schedule.startTime;
        this.endTimeSunday = schedule.endTime;
      }

      this.isUpdate = true;
      this.isAdd = false;
    },

    deleteAssignment(id) {
      console.log(id);
    },

    assignmentLocation(locationId, userTypeId) {
      this.buildings = [];
      this.roles = [];
      this.departments = [];
      if (userTypeId != "") {
        this.isUserTypeEmpty = false;
        var token = localStorage.getItem("token");
        var config = {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
          },
        };
        if (token) {
          axios
            .get(
              "admin/schedule/assignment/location?location_id=" +
                locationId +
                "&user_type_id=" +
                userTypeId,
              config
            )
            .then((res) => {
              if (res.status == "200") {
                this.buildings = res.data.response.buildings;
                this.roles = res.data.response.roles;
                this.departments = res.data.response.departments;
                this.approvers = res.data.response.approvers;
              }
            })
            .catch((err) => {
              if (err.response) {
                console.log(err.response.data.error.message);
              }
            });
        }
      } else {
        this.isUserTypeEmpty = true;
      }
    },

    locationSelection(locationId) {
      var userTypeId = this.assignmentForm.user_type_id;
      this.assignmentLocation(locationId, userTypeId);
    },

    checkUserType(value) {
      if (value != "") {
        this.isUserTypeEmpty = false;
      }
    },

    async showTaskModal(task) {
      console.log(task);
      var roleId = "";
      if (typeof task.dayEl != "undefined") {
        var currentBox = task.dayEl.querySelectorAll(
          ".fc-daygrid-day-events"
        )[0];
        roleId = currentBox.getAttribute("data-role-id");
      } else {
        roleId = task.role_id;
      }
      this.isLoadingTask = true;
      this.$bvModal.show("assign-task");
      this.isSlotsFull = false;
      this.getApprovers();
      await this.getUsers();
      await this.getRoles();
      let date = moment(task.date, "YYYY-MM-DD").format("YYYY-MM-DD");
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      };
      if (token) {
        axios
          .get(
            "admin/schedule/assignment/role?role_id=" +
              roleId +
              "&date=" +
              date,
            config
          )
          .then((res) => {
            if (res.status == "200") {
              console.log(res.data.response);
              this.slots = res.data.response.slots;
              if (this.slots.length < 1) {
                this.isSlotsFull = true;
              }
              this.task.role_id = res.data.response.role_id;
              this.task.role_name = res.data.response.role;
              this.task.id = task.id;
              this.task.approver_id = res.data.response.slots[0].approver_id;
              this.task.date = moment(task.date, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              );
              this.isLoadingTask = false;
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message);
            }
          });
      }
    },

    changeSlot(val) {
      if (val) {
        this.task.status = this.slots.filter((s) => s.slot_id == val)[0].status;
      }
    },

    sendForApprovel() {
      // this.task.status = 'assigned';
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      };
      if (token) {
        axios
          .post("admin/schedule/assign/" + this.task.slot_id, this.task, config)
          .then((res) => {
            if (res.status == "200") {
              Swal.fire({
                title: "Success!",
                text: "Approvel has been send successfully!",
                icon: "success",
                width: 350,
                showConfirmButton: false,
                timer: 1500,
              });
              this.getAssignments();
              this.$bvModal.hide("assign-task");
              this.task = {
                id: "",
                role_id: "",
                user_id: "",
                approver_id: [],
                date: "",
                slot_id: "",
                status: "",
              };
            }
          })
          .catch((err) => {
            if (err.response) {
              Swal.fire({
                title: "Error!",
                text: err.response.data.error.message,
                icon: "danger",
                width: 350,
                showConfirmButton: true,
              });
            }
          });
      }
    },

    showEmailModal(user_id, user_name) {
      this.$bvModal.show("send-email");
      this.sendEmailForm.receiver_id = user_id;
      this.sendEmailForm.receiver_name = user_name;
    },

    sendEmail() {
      this.sendEmailForm.receiver_id = this.userId;
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      };
      if (token) {
        axios
          .post("admin/notifications", this.sendEmailForm, config)
          .then((res) => {
            if (res.status == "200") {
              Swal.fire({
                title: "Success!",
                text: "Email Sent successfully!",
                icon: "success",
                width: 350,
                showConfirmButton: false,
                timer: 1500,
              });
              this.showModal = false;
              this.sendEmailForm = {
                subject: "",
                description: "<p>Content of the editor.</p>",
                receiver_id: null,
              };
            }
          })
          .catch((err) => {
            if (err.response) {
              Swal.fire({
                title: "Error!",
                text: err.response.data.error.message,
                icon: "danger",
                width: 350,
                showConfirmButton: true,
              });
            }
          });
      }
    },

    cancelAssignment(id) {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      };
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to cancel this Assignment!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, Remove it!",
      }).then((result) => {
        if (result.value) {
          if (token) {
            axios
              .delete("admin/schedule/" + id, config)
              .then((res) => {
                if (res.status == "200") {
                  Swal.fire({
                    title: "Canceled!",
                    text: "Assignment has been Canceled!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.getAssignments();
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              });
          }
        }
      });
    },

    resetForm() {
      this.assignmentForm = {
        user_type_id: "",
        location_id: "",
        building_id: "",
        department_id: "",
        role_id: "",
        approver_id: "",
        started_at: "",
        ended_at: "",
        days: [],
        time: [],
        user_id: "",
        volunteers: [],
      };
      this.startTimeMonday = "";
      this.endTimeMonday = "";
      this.startTimeTuesday = "";
      this.endTimeTuesday = "";
      this.startTimeWednesday = "";
      this.endTimeWednesday = "";
      this.startTimeThursday = "";
      this.endTimeThursday = "";
      this.startTimeFriday = "";
      this.endTimeFriday = "";
      this.startTimeSaturday = "";
      this.endTimeSaturday = "";
      this.startTimeSunday = "";
      this.endTimeSunday = "";
      this.isMonday = false;
      this.isTuesday = false;
      this.isWednesday = false;
      this.isThursday = false;
      this.isFriday = false;
      this.isSaturday = false;
      this.isSunday = false;
      this.showMonday = true;
      this.showTuesday = true;
      this.showWednesday = true;
      this.showThursday = true;
      this.showFriday = true;
      this.showSaturday = true;
      this.showSunday = true;
    },
  },
  watch: {
    isMonday(val) {
      if (val) {
        this.assignmentForm.days[0] = "monday";
      } else {
        const index = this.assignmentForm.days.indexOf("monday");
        if (index > -1) {
          this.assignmentForm.days.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.assignmentForm.time.splice(0, 1);
        this.assignmentForm.time.splice(1, 1);
        this.startTimeMonday = "";
        this.endTimeMonday = "";
      }
    },
    isTuesday(val) {
      if (val) {
        this.assignmentForm.days[1] = "tuesday";
      } else {
        const index = this.assignmentForm.days.indexOf("tuesday");
        if (index > -1) {
          this.assignmentForm.days.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.assignmentForm.time.splice(2, 1);
        this.assignmentForm.time.splice(3, 1);
        this.startTimeTuesday = "";
        this.endTimeTuesday = "";
      }
    },
    isWednesday(val) {
      if (val) {
        this.assignmentForm.days[2] = "wednesday";
      } else {
        const index = this.assignmentForm.days.indexOf("wednesday");
        if (index > -1) {
          this.assignmentForm.days.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.assignmentForm.time.splice(4, 1);
        this.assignmentForm.time.splice(5, 1);
        this.startTimeWednesday = "";
        this.endTimeWednesday = "";
      }
    },
    isThursday(val) {
      if (val) {
        this.assignmentForm.days[3] = "thursday";
      } else {
        const index = this.assignmentForm.days.indexOf("thursday");
        if (index > -1) {
          this.assignmentForm.days.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      this.assignmentForm.time.splice(6, 1);
      this.assignmentForm.time.splice(7, 1);
      this.startTimeThursday = "";
      this.endTimeThursday = "";
    },
    isFriday(val) {
      if (val) {
        this.assignmentForm.days[4] = "friday";
      } else {
        const index = this.assignmentForm.days.indexOf("friday");
        if (index > -1) {
          this.assignmentForm.days.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      this.assignmentForm.time.splice(8, 1);
      this.assignmentForm.time.splice(9, 1);
      this.startTimeFriday = "";
      this.endTimeFriday = "";
    },
    isSaturday(val) {
      if (val) {
        this.assignmentForm.days[5] = "saturday";
      } else {
        const index = this.assignmentForm.days.indexOf("saturday");
        if (index > -1) {
          this.assignmentForm.days.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      this.assignmentForm.time.splice(10, 1);
      this.assignmentForm.time.splice(11, 1);
      this.startTimeSaturday = "";
      this.endTimeSaturday = "";
    },
    isSunday(val) {
      if (val) {
        this.assignmentForm.days[6] = "sunday";
      } else {
        const index = this.assignmentForm.days.indexOf("sunday");
        if (index > -1) {
          this.assignmentForm.days.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      this.assignmentForm.time.splice(12, 1);
      this.assignmentForm.time.splice(13, 1);
      this.startTimeSunday = "";
      this.endTimeSunday = "";
    },
    // startTimeMonday:'',
    // endTimeMonday:'',
    // startTimeTuesday:'',
    // endTimeTuesday:'',
    // startTimeWednesday:'',
    // endTimeWednesday:'',
    // startTimeThursday:'',
    // endTimeThursday:'',
    // startTimeFriday:'',
    // endTimeFriday:'',

    startTimeMonday(val) {
      console.log(val);
      if (val) {
        this.assignmentForm.time[0] = val;
      } else {
        this.assignmentForm.time.splice(0, 1);
      }
    },
    endTimeMonday(val) {
      console.log(val);
      if (val) {
        this.assignmentForm.time[1] = val;
      } else {
        this.assignmentForm.time.splice(1, 1);
      }
    },
    startTimeTuesday(val) {
      if (val) {
        this.assignmentForm.time[2] = val;
      } else {
        this.assignmentForm.time.splice(2, 1);
      }
    },
    endTimeTuesday(val) {
      if (val) {
        this.assignmentForm.time[3] = val;
      } else {
        this.assignmentForm.time.splice(3, 1);
      }
    },
    startTimeWednesday(val) {
      if (val) {
        this.assignmentForm.time[4] = val;
      } else {
        this.assignmentForm.time.splice(4, 1);
      }
    },
    endTimeWednesday(val) {
      if (val) {
        this.assignmentForm.time[5] = val;
      } else {
        this.assignmentForm.time.splice(5, 1);
      }
    },
    startTimeThursday(val) {
      if (val) {
        this.assignmentForm.time[6] = val;
      } else {
        this.assignmentForm.time.splice(6, 1);
      }
    },
    endTimeThursday(val) {
      if (val) {
        this.assignmentForm.time[7] = val;
      } else {
        this.assignmentForm.time.splice(7, 1);
      }
    },
    startTimeFriday(val) {
      if (val) {
        this.assignmentForm.time[8] = val;
      } else {
        this.assignmentForm.time.splice(8, 1);
      }
    },
    endTimeFriday(val) {
      if (val) {
        this.assignmentForm.time[9] = val;
      } else {
        this.assignmentForm.time.splice(9, 1);
      }
    },
    startTimeSaturday(val) {
      if (val) {
        this.assignmentForm.time[10] = val;
      } else {
        this.assignmentForm.time.splice(10, 1);
      }
    },
    endTimeSaturday(val) {
      if (val) {
        this.assignmentForm.time[11] = val;
      } else {
        this.assignmentForm.time.splice(11, 1);
      }
    },
    startTimeSunday(val) {
      if (val) {
        this.assignmentForm.time[12] = val;
      } else {
        this.assignmentForm.time.splice(12, 1);
      }
    },
    endTimeSunday(val) {
      if (val) {
        this.assignmentForm.time[13] = val;
      } else {
        this.assignmentForm.time.splice(13, 1);
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="d-flex">
      <div class="me-2">
        <h5 class="card-title mb-3">Volunteer Schedule</h5>
      </div>

      <div class="mb-4 mdl-btns ms-auto">
        <!--Add Assignment Modal-->
        <b-button @click="showAddModal" variant="primary"
          >Add Assignment</b-button
        >
        <b-modal
          id="add-assignment"
          centered
          :title="modalTitle"
          size="lg"
          title-class="font-18"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="mb-3 col-6">
                <label class="mt-0">Select Type</label>
                <b-form-select
                  @change="checkUserType($event)"
                  class="form-select"
                  v-model="assignmentForm.user_type_id"
                  :options="types"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.assignmentForm.user_type_id.$error,
                  }"
                >
                  <option slot="first" :value="null" disabled>
                    Select Type
                  </option>
                </b-form-select>
                <div
                  v-if="typeSubmit && $v.assignmentForm.user_type_id.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.assignmentForm.user_type_id.required"
                    >User Type is required.</span
                  >
                </div>
              </div>

              <div class="mb-3 col-6">
                <label class="mt-0">Select Location</label>
                <b-form-select
                  @change="locationSelection($event)"
                  class="form-select"
                  v-model="assignmentForm.location_id"
                  :options="locations"
                  value-field="id"
                  text-field="name"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.assignmentForm.location_id.$error,
                  }"
                >
                  <option slot="first" :value="null" disabled>
                    Select Location
                  </option>
                </b-form-select>
                <span v-if="isUserTypeEmpty" class="text-danger"
                  >Please select user type</span
                >
                <div
                  v-if="typeSubmit && $v.assignmentForm.location_id.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.assignmentForm.location_id.required"
                    >Location is required.</span
                  >
                </div>
              </div>

              <div class="mb-3 col-6">
                <label class="mt-0">Select Building</label>
                <b-form-select
                  class="form-select"
                  v-model="assignmentForm.building_id"
                  :options="buildings"
                  value-field="id"
                  text-field="name"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.assignmentForm.building_id.$error,
                  }"
                >
                  <option slot="first" :value="null" disabled>
                    Select Building
                  </option>
                </b-form-select>
                <div
                  v-if="typeSubmit && $v.assignmentForm.building_id.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.assignmentForm.building_id.required"
                    >Building is required.</span
                  >
                </div>
              </div>

              <!-- <div class="mb-3 col-6">

                    <label class="mt-0">Volunteer Department Assignments</label>
                    <b-form-select class="form-select" v-model="assignmentForm.department_id" :options="departments"
                                   value-field="id"
                                   text-field="name"
                                   :class="{'is-invalid': typeSubmit && $v.assignmentForm.department_id.$error}"
                    >
                      <option slot="first" :value="null" disabled>Select Location</option>
                    </b-form-select>
                    <div
                        v-if="typeSubmit && $v.assignmentForm.department_id.$error"
                        class="invalid-feedback"
                    >
                  <span v-if="!$v.assignmentForm.department_id.required"
                  >Volunteer Department Assignment is required.</span>
                    </div>

                  </div> -->

              <div class="mb-3 col-6">
                <label>Role</label>
                <b-form-select
                  class="form-select"
                  v-model="assignmentForm.role_id"
                  :options="roles"
                  value-field="id"
                  text-field="name"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.assignmentForm.role_id.$error,
                  }"
                >
                  <option slot="first" :value="null" disabled>
                    Select Role
                  </option>
                </b-form-select>
                <div
                  v-if="typeSubmit && $v.assignmentForm.role_id.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.assignmentForm.role_id.required"
                    >Assignee is required.</span
                  >
                </div>
              </div>

              <div class="mb-3 col-6">
                <label class="mt-0">Approver</label>
                <b-form-select
                  class="form-select"
                  v-model="assignmentForm.approver_id"
                  :options="approvers"
                  value-field="id"
                  text-field="username"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.assignmentForm.approver_id.$error,
                  }"
                >
                  <!-- <option slot="first" :value="null" disabled>Select Approver</option> -->
                  <option slot="first" :value="null" disabled>
                    Select Approver
                  </option>
                </b-form-select>
                <div
                  v-if="typeSubmit && $v.assignmentForm.approver_id.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.assignmentForm.approver_id.required"
                    >Approver is required.</span
                  >
                </div>
              </div>

              <div class="mb-3 col-6">
                <label class="mt-0">Role Assignment Status</label>
                <b-form-select
                  class="form-select"
                  v-model="assignmentForm.status"
                  :options="assignmentStatus"
                  :class="{
                    'is-invalid': typeSubmit && $v.assignmentForm.status.$error,
                  }"
                >
                  <!-- <option slot="first" :value="null" disabled>Select Approver</option> -->
                  <option slot="first" :value="null" disabled>
                    Select Status
                  </option>
                </b-form-select>
                <div
                  v-if="typeSubmit && $v.assignmentForm.status.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.assignmentForm.status.required"
                    >Status is required.</span
                  >
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <!-- <div v-if="isAdd" class="mb-3 col-6">
                    <label class="mt-0">Select Volunteers</label>

                      <b-form-select multiple class="form-select" v-model="assignmentForm.volunteers" :options="users"
                                    value-field="id"
                                    text-field="username"
                                    :class="{'is-invalid': typeSubmit && $v.assignmentForm.volunteers.$error,}"
                      >
                        <option slot="first" :value="null" disabled>Select Volunteers</option>
                      </b-form-select>

                      <div
                          v-if="typeSubmit && $v.assignmentForm.volunteers.$error"
                          class="invalid-feedback"
                      >
                              <span v-if="!$v.assignmentForm.volunteers.required"
                              >Please select at least one Volunteer.</span>
                      </div>
                  </div> -->

              <!-- <div v-if="isUpdate" class="mb-3 col-6">
                    <label class="mt-0">Select Volunteer</label>

                      <b-form-select class="form-select" v-model="assignmentForm.user_id" :options="users"
                                    value-field="id"
                                    text-field="username"
                                    :class="{'is-invalid': typeSubmit && $v.assignmentForm.user_id.$error,}"
                      >
                        <option slot="first" :value="null" disabled>Select Volunteer</option>
                      </b-form-select>

                      <div
                          v-if="typeSubmit && $v.assignmentForm.user_id.$error"
                          class="invalid-feedback"
                      >
                              <span v-if="!$v.assignmentForm.user_id.required"
                              >Please select volunteer.</span>
                      </div>
                  </div> -->
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <label>Time Frame</label>
              </div>
              <div class="col-4">
                <!-- <b-form-input @change="showDays"
                                  v-model="assignmentForm.started_at"
                                  type="date"
                                  :min="new Date().toISOString().substr(0, 10)"
                    ></b-form-input> -->
                <b-form-input
                  v-if="isAdd"
                  @change="showDays"
                  v-model="assignmentForm.started_at"
                  type="date"
                ></b-form-input>
                <b-form-input
                  v-if="isUpdate"
                  readonly
                  @change="showDays"
                  v-model="assignmentForm.started_at"
                  type="date"
                ></b-form-input>

                <div
                  v-if="typeSubmit && $v.assignmentForm.started_at.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.assignmentForm.started_at.required"
                    >Start Date is required.</span
                  >
                </div>
              </div>
              <div class="col-4">
                <!-- <b-form-input @change="showDays"
                                  v-model="assignmentForm.ended_at"
                                  type="date"
                                  :min="new Date().toISOString().substr(0, 10)"
                    ></b-form-input> -->
                <b-form-input
                  v-if="isAdd"
                  @change="showDays"
                  v-model="assignmentForm.ended_at"
                  type="date"
                ></b-form-input>
                <b-form-input
                  v-if="isUpdate"
                  readonly
                  @change="showDays"
                  v-model="assignmentForm.ended_at"
                  type="date"
                ></b-form-input>

                <div
                  v-if="typeSubmit && $v.assignmentForm.ended_at.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.assignmentForm.ended_at.required"
                    >End Date is required.</span
                  >
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h4 class="font-size-14">Select Day/Times:</h4>
              </div>
            </div>

            <div class="row px-3">
              <div
                class="form-check col-2 mb-3 me-1"
                :class="{ 'bg-secondary bg-soft pe-none': showMonday }"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="isMonday"
                  id="monday"
                />
                <label class="form-check-label" for="monday"> Monday </label>
              </div>

              <div
                class="form-check col-2 mb-3 me-1"
                :class="{ 'bg-secondary bg-soft pe-none': showTuesday }"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="isTuesday"
                  id="tuesday"
                />
                <label class="form-check-label" for="tuesday"> Tuesday </label>
              </div>

              <div
                class="form-check col-2 mb-3 me-1"
                :class="{ 'bg-secondary bg-soft pe-none': showWednesday }"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="isWednesday"
                  id="wednesday"
                />
                <label class="form-check-label" for="wednesday">
                  Wednesday
                </label>
              </div>

              <div
                class="form-check col-2 mb-3 me-1"
                :class="{ 'bg-secondary bg-soft pe-none': showThursday }"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="isThursday"
                  id="thursday"
                />
                <label class="form-check-label" for="thursday">
                  Thursday
                </label>
              </div>

              <div
                class="form-check col-2 mb-3 me-1"
                :class="{ 'bg-secondary bg-soft pe-none': showFriday }"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="isFriday"
                  id="friday"
                />
                <label class="form-check-label" for="friday"> Friday </label>
              </div>

              <div
                class="form-check col-2 mb-3 me-1"
                :class="{ 'bg-secondary bg-soft pe-none': showSaturday }"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="isSaturday"
                  id="saturday"
                />
                <label class="form-check-label" for="saturday">
                  Saturday
                </label>
              </div>

              <div
                class="form-check col-2 mb-3 me-1"
                :class="{ 'bg-secondary bg-soft pe-none': showSunday }"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="isSunday"
                  id="sunday"
                />
                <label class="form-check-label" for="sunday"> Sunday </label>
              </div>
              <div class="col-1"></div>
            </div>

            <div class="times-wrap">
              <div class="d-flex mb-2 align-items-baseline" v-if="isMonday">
                <label class="mb-0 col-2 me-3 fw-bold">Monday:</label>
                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">Start</label>
                  <date-picker
                    v-model="startTimeMonday"
                    format="hh:mm A"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>

                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">End</label>
                  <date-picker
                    v-model="endTimeMonday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>
              </div>

              <div class="d-flex mb-2 align-items-baseline" v-if="isTuesday">
                <label class="mb-0 col-2 me-3 fw-bold">Tuesday:</label>
                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">Start</label>
                  <date-picker
                    v-model="startTimeTuesday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>

                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">End</label>
                  <date-picker
                    v-model="endTimeTuesday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>
              </div>

              <div class="d-flex mb-2 align-items-baseline" v-if="isWednesday">
                <label class="mb-0 col-2 me-3 fw-bold">Wednesday:</label>
                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">Start</label>
                  <date-picker
                    v-model="startTimeWednesday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>

                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">End</label>
                  <date-picker
                    v-model="endTimeWednesday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>
              </div>

              <div class="d-flex mb-2 align-items-baseline" v-if="isThursday">
                <label class="mb-0 col-2 me-3 fw-bold">Thursday:</label>
                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">Start</label>
                  <date-picker
                    v-model="startTimeThursday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>

                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">End</label>
                  <date-picker
                    v-model="endTimeThursday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>
              </div>

              <div class="d-flex mb-2 align-items-baseline" v-if="isFriday">
                <label class="mb-0 col-2 me-3 fw-bold">Friday:</label>
                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">Start</label>
                  <date-picker
                    v-model="startTimeFriday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>

                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">End</label>
                  <date-picker
                    v-model="endTimeFriday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>
              </div>

              <div class="d-flex mb-2 align-items-baseline" v-if="isSaturday">
                <label class="mb-0 col-2 me-3 fw-bold">Saturday:</label>
                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">Start</label>
                  <date-picker
                    v-model="startTimeSaturday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>

                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">End</label>
                  <date-picker
                    v-model="endTimeSaturday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>
              </div>

              <div class="d-flex mb-2 align-items-baseline" v-if="isSunday">
                <label class="mb-0 col-2 me-3 fw-bold">Sunday:</label>
                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">Start</label>
                  <date-picker
                    v-model="startTimeSunday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>

                <p class="mb-0 d-flex align-items-baseline">
                  <label class="mb-0 ms-3 me-1">End</label>
                  <date-picker
                    v-model="endTimeSunday"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="hh:mm a"
                  ></date-picker>
                </p>
              </div>
            </div>

            <div class="mb-0">
              <div>
                <button
                  v-if="isAdd"
                  @click="addAssignment"
                  type="button"
                  class="btn btn-primary"
                >
                  Add
                </button>
                <button
                  v-if="isUpdate"
                  @click="updateAssignment"
                  type="button"
                  class="btn btn-primary"
                >
                  Update
                </button>
              </div>
            </div>
          </form>
        </b-modal>
      </div>
    </div>

    <form class="row align-items-center form-inline mb-4 border p-3">
      <div class="col-md-3">
        <select
          v-model="dataFormat"
          @change="dataFormatView(dataFormat)"
          class="form-select custom-select"
        >
          <option value="">Select View</option>
          <option value="list">List</option>
          <option value="calendar">Calendar</option>
        </select>
      </div>

      <div class="col-md-5 sm-hidden xs-hidden"></div>
      <div class="col-md-4 pull-right">
        <div class="app-search pt-0 pb-0">
          <div class="position-relative">
            <input
              type="text"
              placeholder="Search..."
              class="form-control"
            /><span class="bx bx-search-alt"></span>
          </div>
        </div>
      </div>
    </form>

    <!--Calendar View-->
    <div class="row calendar-view" v-if="isCalendar">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar
                ref="fullCalendar"
                :options="calendarOptions"
              ></FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showModal"
      title="Add New Event"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="name">Event Name</label>
              <input
                v-model="event.title"
                type="text"
                class="form-control"
                placeholder="Insert Event name"
                :class="{ 'is-invalid': submitted && $v.event.title.$error }"
              />
              <div
                v-if="submitted && !$v.event.title.required"
                class="invalid-feedback"
              >
                This value is required.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label class="control-label">Category</label>
              <select
                v-model="event.category"
                class="form-control"
                name="category"
                :class="{ 'is-invalid': submitted && $v.event.category.errors }"
              >
                <option
                  v-for="option in categories"
                  :key="option.backgroundColor"
                  :value="`${option.value}`"
                >
                  {{ option.name }}
                </option>
              </select>
              <div
                v-if="submitted && !$v.event.category.required"
                class="invalid-feedback"
              >
                This value is required.
              </div>
            </div>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="hideModal">Close</b-button>
          <b-button type="submit" variant="success" class="ms-1"
            >Create event
          </b-button>
        </div>
      </form>
    </b-modal>

    <!-- Edit Modal -->
    <b-modal
      v-model="eventModal"
      title="Edit Event"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
    >
      <div slot="modal-title">Edit Event</div>
      <form @submit.prevent="editSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="name">Event Name</label>
              <input
                id="name"
                v-model="editevent.editTitle"
                type="text"
                class="form-control"
                placeholder="Insert Event name"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label class="control-label">Category</label>
              <select
                v-model="editevent.editcategory"
                class="form-control"
                name="category"
              >
                <option
                  v-for="option in categories"
                  :key="option.backgroundColor"
                  :value="`${option.value}`"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="text-end p-3">
          <b-button variant="light" @click="closeModal">Close</b-button>
          <b-button class="ms-1" variant="danger" @click="confirm"
            >Delete
          </b-button>
          <b-button class="ms-1" variant="success" @click="editSubmit"
            >Save
          </b-button>
        </div>
      </form>
    </b-modal>
    <!--Calendar View End-->

    <!--Calendar View Week-->
    <div class="row" v-if="isWeek">
      <div class="col-md-2 pe-0">
        <table class="table table-sm align-middle table-nowrap mb-0">
          <thead class="table-light">
            <tr>
              <th>Time Slots</th>
            </tr>
          </thead>
          <tbody>
            <tr data-time="12:00 pm - 01:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  12:00 PM - 01:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="01:00 pm - 02:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  01:00 PM - 02:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="02:00 pm - 03:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  02:00 PM - 03:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="03:00 pm - 04:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  03:00 PM - 04:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="04:00 pm - 05:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  04:00 - 05:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="05:00 pm - 06:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  05:00 PM - 06:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="06:00 pm - 07:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  06:00 PM - 07:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="07:00 pm - 08:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  07:00 PM - 08:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="08:00 pm - 09:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  08:00 PM - 09:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="09:00 pm - 10:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  09:00 PM - 10:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="10:00 pm - 11:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  10:00 PM - 11:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="11:00 pm - 12:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  11:00 PM - 12:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="12:00 am - 01:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  12:00 AM - 01:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="01:00 am - 02:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  01:00 AM - 02:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="02:00 am - 03:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  02:00 AM - 03:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="03:00 am - 04:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  03:00 AM - 04:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="04:00 am - 05:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  04:00 AM - 05:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="05:00 am - 06:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  05:00 AM - 06:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="06:00 am - 07:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  06:00 AM - 07:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="07:00 am - 08:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  07:00 AM - 08:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="08:00 am - 09:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  08:00 AM - 09:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="09:00 am - 10:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  09:00 AM - 10:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="10:00 am - 11:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  10:00 AM - 11:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="11:00 am - 12:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  11:00 AM - 12:00 AM
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-10 ps-0">
        <div class="table-responsive mb-5">
          <table
            class="table week-table table-sm table-bordered align-middle table-nowrap mb-0"
          >
            <tr class="text-center" v-if="isLoadingWeek">
              <b-spinner
                class="m-2"
                variant="primary"
                role="status"
              ></b-spinner>
            </tr>

            <thead class="table-light">
              <tr>
                <th
                  scope="col"
                  v-for="(day, dayIndex) in weekDays"
                  :key="dayIndex"
                >
                  {{ day }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr data-time="12:00 pm - 01:00 pm"></tr>

              <tr data-time="01:00 pm - 02:00 pm"></tr>

              <tr data-time="02:00 pm - 03:00 pm"></tr>

              <tr data-time="03:00 pm - 04:00 pm"></tr>

              <tr data-time="04:00 pm - 05:00 pm"></tr>

              <tr data-time="05:00 pm - 06:00 pm"></tr>

              <tr data-time="06:00 pm - 07:00 pm"></tr>

              <tr data-time="07:00 pm - 08:00 pm"></tr>

              <tr data-time="08:00 pm - 09:00 pm"></tr>

              <tr data-time="09:00 pm - 10:00 pm"></tr>

              <tr data-time="10:00 pm - 11:00 pm"></tr>

              <tr data-time="11:00 pm - 12:00 am"></tr>

              <tr data-time="12:00 am - 01:00 am"></tr>

              <tr data-time="01:00 am - 02:00 am"></tr>

              <tr data-time="02:00 am - 03:00 am"></tr>

              <tr data-time="03:00 am - 04:00 am"></tr>

              <tr data-time="04:00 am - 05:00 am"></tr>

              <tr data-time="05:00 am - 06:00 am"></tr>

              <tr data-time="06:00 am - 07:00 am"></tr>

              <tr data-time="07:00 am - 08:00 am"></tr>

              <tr data-time="08:00 am - 09:00 am"></tr>

              <tr data-time="09:00 am - 10:00 am"></tr>

              <tr data-time="10:00 am - 11:00 am"></tr>

              <tr data-time="11:00 am - 12:00 am"></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--Calendar View Week-->

    <div class="row" v-if="isDay">
      <div class="col-md-2 pe-0">
        <table class="table table-sm align-middle table-nowrap mb-0">
          <thead class="table-light">
            <tr>
              <th>Time Slots</th>
            </tr>
          </thead>
          <tbody>
            <tr data-time="12:00 pm - 01:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  12:00 PM - 01:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="01:00 pm - 02:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  01:00 PM - 02:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="02:00 pm - 03:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  02:00 PM - 03:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="03:00 pm - 04:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  03:00 PM - 04:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="04:00 pm - 05:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  04:00 - 05:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="05:00 pm - 06:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  05:00 PM - 06:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="06:00 pm - 07:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  06:00 PM - 07:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="07:00 pm - 08:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  07:00 PM - 08:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="08:00 pm - 09:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  08:00 PM - 09:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="09:00 pm - 10:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  09:00 PM - 10:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="10:00 pm - 11:00 pm">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  10:00 PM - 11:00 PM
                </h5>
              </td>
            </tr>

            <tr data-time="11:00 pm - 12:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  11:00 PM - 12:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="12:00 am - 01:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  12:00 AM - 01:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="01:00 am - 02:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  01:00 AM - 02:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="02:00 am - 03:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  02:00 AM - 03:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="03:00 am - 04:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  03:00 AM - 04:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="04:00 am - 05:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  04:00 AM - 05:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="05:00 am - 06:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  05:00 AM - 06:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="06:00 am - 07:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  06:00 AM - 07:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="07:00 am - 08:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  07:00 AM - 08:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="08:00 am - 09:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  08:00 AM - 09:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="09:00 am - 10:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  09:00 AM - 10:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="10:00 am - 11:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  10:00 AM - 11:00 AM
                </h5>
              </td>
            </tr>

            <tr data-time="11:00 am - 12:00 am">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  11:00 AM - 12:00 AM
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-10 ps-0">
        <div class="table-responsive mb-5">
          <table
            class="table day-table table-sm table-bordered align-middle table-nowrap mb-0"
          >
            <tr class="text-center" v-if="isLoadingDay">
              <b-spinner
                class="m-2"
                variant="primary"
                role="status"
              ></b-spinner>
            </tr>

            <thead class="table-light">
              <tr>
                <th
                  scope="col"
                  v-for="(role, roleIndex) in dayRoles"
                  :key="roleIndex"
                >
                  {{ role.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr data-time="12:00 pm - 01:00 pm"></tr>

              <tr data-time="01:00 pm - 02:00 pm"></tr>

              <tr data-time="02:00 pm - 03:00 pm"></tr>

              <tr data-time="03:00 pm - 04:00 pm"></tr>

              <tr data-time="04:00 pm - 05:00 pm"></tr>

              <tr data-time="05:00 pm - 06:00 pm"></tr>

              <tr data-time="06:00 pm - 07:00 pm"></tr>

              <tr data-time="07:00 pm - 08:00 pm"></tr>

              <tr data-time="08:00 pm - 09:00 pm"></tr>

              <tr data-time="09:00 pm - 10:00 pm"></tr>

              <tr data-time="10:00 pm - 11:00 pm"></tr>

              <tr data-time="11:00 pm - 12:00 am"></tr>

              <tr data-time="12:00 am - 01:00 am"></tr>

              <tr data-time="01:00 am - 02:00 am"></tr>

              <tr data-time="02:00 am - 03:00 am"></tr>

              <tr data-time="03:00 am - 04:00 am"></tr>

              <tr data-time="04:00 am - 05:00 am"></tr>

              <tr data-time="05:00 am - 06:00 am"></tr>

              <tr data-time="06:00 am - 07:00 am"></tr>

              <tr data-time="07:00 am - 08:00 am"></tr>

              <tr data-time="08:00 am - 09:00 am"></tr>

              <tr data-time="09:00 am - 10:00 am"></tr>

              <tr data-time="10:00 am - 11:00 am"></tr>

              <tr data-time="11:00 am - 12:00 am"></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!--List View-->
    <div>
      <div class="table-responsive" v-if="isListing">
        <table class="table table-sm align-middle table-nowrap mb-0">
          <thead class="table-light">
            <tr>
              <th scope="col">Id</th>
              <th scope="col">User</th>
              <th scope="col">Roles</th>
              <th scope="col">Date</th>
              <th scope="col">Time Slot</th>
              <!-- <th scope="col">Department</th> -->
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="noRecord">
              <td colspan="8" class="p-0">
                <p class="font-size-16 text-center mt-2 mb-0">
                  Record Not Found!
                </p>
              </td>
            </tr>

            <tr v-if="isLoading">
              <td colspan="8" class="text-center p-0">
                <b-spinner
                  class="m-2"
                  variant="primary"
                  role="status"
                ></b-spinner>
              </td>
            </tr>

            <tr v-else v-for="(schedule, index) in schedules.data" :key="index">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{ schedule.id }}
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{
                    schedule.volunteer_name ? schedule.volunteer_name : "N/A"
                  }}
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{ schedule.role }}
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <!-- {{new Date(schedule.date).toLocaleString().split(',')[0]}} -->
                  {{ schedule.date | moment }}
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{ schedule.start_time }} to {{ schedule.end_time }}
                </h5>
              </td>
              <!-- <td>
              <h5 class="font-size-13 text-truncate mb-1">
                {{schedule.department}}
              </h5>
            </td> -->
              <td>
                <b-button
                  id="show-btn"
                  @click="showEditModal(schedule)"
                  variant="primary"
                  title="Edit"
                >
                  <i class="bx bx-pencil"></i>
                </b-button>
                <b-button
                  class="ms-2"
                  @click="cancelAssignment(schedule.id)"
                  variant="primary"
                  title="Cancel"
                >
                  <i class="bx bx-x"></i>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        class="mt-4"
        :data="schedules"
        :limit="10"
        @pagination-change-page="getAssignments"
      ></pagination>
    </div>
    <!--List View End-->

    <b-modal
      id="check-status"
      centered
      :title="statusDate"
      title-class="font-18"
      size="lg"
      hide-footer
    >
      <form>
        <div class="table-responsive">
          <table class="table table-sm align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th scope="col">Role</th>
                <th scope="col">Requested Date</th>
                <th scope="col">Approved Date</th>
                <th scope="col">Approver(s)</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    {{ checkStatus.role }}
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    {{ checkStatus.requested_date }}
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    {{ checkStatus.approved_date }}
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    {{ checkStatus.approvers }}
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    {{ checkStatus.status }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mb-0 mt-2">
          <div class="text-end">
            <button
              @click="deleteAssignment(checkStatus.assignment_id)"
              type="button"
              class="btn btn-primary me-2"
            >
              Delete Request
            </button>

            <button
              v-if="checkStatus.status == 'awaiting'"
              @click="
                showEmailModal(checkStatus.user_id, checkStatus.user_name)
              "
              type="button"
              class="btn btn-primary"
            >
              Send follow Up
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <!--Assign User-->
    <b-modal
      id="assign-task"
      title="Assign User"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      size="lg"
    >
      <form>
        <div class="text-center" v-if="isLoadingTask">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>

        <div v-else>
          <div class="row">
            <div class="col-4">
              <label>Selected Role</label>
              <input
                v-model="task.role_name"
                type="text"
                class="form-control pe-none bg-secondary bg-soft"
              />
            </div>

            <div class="col-4">
              <label>Date</label>
              <input
                v-model="task.date"
                type="text"
                class="form-control pe-none bg-secondary bg-soft"
              />
            </div>

            <div class="col-4">
              <label
                >Select Slot
                <code v-if="isSlotsFull">(Slots Assigned)</code></label
              >
              <b-form-select
                class="form-select w-100"
                v-model="task.slot_id"
                :options="slots"
                value-field="slot_id"
                text-field="slot_time"
                :class="
                  isSlotsFull == true ? 'pe-none bg-secondary bg-soft' : ''
                "
              >
                <option slot="first" :value="null" disabled>Select Slot</option>
              </b-form-select>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="name">Select User</label>
                <b-form-select
                  class="form-select"
                  v-model="task.user_id"
                  :options="users"
                  value-field="id"
                  text-field="username"
                >
                  <option slot="first" :value="null" disabled>
                    Select User
                  </option>
                </b-form-select>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="name">Selected Approver</label>
                <b-form-select
                  class="form-select pe-none bg-secondary bg-soft"
                  v-model="task.approver_id"
                  :options="approvers"
                  value-field="id"
                  text-field="username"
                >
                  <option slot="first" :value="null" disabled>
                    Select Approver
                  </option>
                </b-form-select>
              </div>
            </div>
          </div>

          <div class="text-end mt-3">
            <b-button variant="light" @click="hideModal">Close</b-button>
            <b-button
              type="button"
              @click="sendForApprovel"
              :class="isSlotsFull == true ? 'pe-none disabled' : ''"
              variant="primary"
              class="ms-1"
              >Send for Approvel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="send-email"
      centered
      title="Send Message"
      title-class="font-18"
      hide-footer
    >
      <form>
        <div class="mb-3 d-none">
          <input
            type="text"
            disabled
            v-model="sendEmailForm.receiver_id"
            class="form-control text-muted"
            placeholder="To"
          />
        </div>

        <div class="mb-3">
          <input
            type="text"
            disabled
            v-model="sendEmailForm.receiver_name"
            class="form-control text-muted"
            placeholder="Receiver Name"
          />
        </div>

        <div class="mb-3">
          <input
            type="text"
            v-model="sendEmailForm.subject"
            class="form-control"
            placeholder="Subject"
          />
        </div>

        <div class="mb-3">
          <ckeditor
            v-model="sendEmailForm.description"
            :editor="editor"
          ></ckeditor>
        </div>
      </form>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showModal = false"
          >Close</b-button
        >
        <b-button @click="sendEmail" variant="primary">
          Send
          <i class="fab fa-telegram-plane ms-1"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<style scoped></style>
